var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.785 0h24v24h-24z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.785)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#e8b807",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.375c3.13 0 5.956.918 8.005 2.379 2.193 1.563 3.495 3.739 3.495 6.108 0 2.369-1.302 4.545-3.495 6.108-2.049 1.46-4.875 2.379-8.005 2.379-2.734 3.712-8.385 2.918-8.385 2.918S2.146 22.06.543 21.33c1.757-.344 2.738-.92 2.738-.92s.983-.576 2.144-1.944c.098-.116.203-.274.315-.474-1.421-.678-2.617-1.578-3.5-2.623C1.125 14.053.5 12.507.5 10.862c0-2.37 1.302-4.545 3.495-6.108C6.044 3.293 8.87 2.375 12 2.375z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M6.375 12.375h11.25M6.375 7.875h11.25"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon-message.3e34d98d03b66c70ea10f28f07e71a75.svg";
export { ForwardRef as ReactComponent };